export const CHAT_SUGGESTIONS = [
  /* =========================
    GENERAL ANALYSES
  ========================= */

  {
    title: "Descriptive Statistics",
    triggers: [
      "describe",
      "summary",
      "summarize",
      "distribution",
      "baseline",
      "characteristics",
      "mean",
      "median",
      "sd",
      "frequency",
      "proportion",
    ],
    commands: [
      "Provide summary statistics for [Variable 1], [Variable 2].",
      "Provide frequency tables for [Variable 1], [Variable 2].",
    ],
    example: "Provide descriptive statistics for age and BMI overall and by sex.",
  },
  {
    title: "Group Comparison",
    triggers: [
      "compare",
      "difference",
      "differences",
      "across",
      "between groups",
      "group comparison",
      "table 1",
      "table1",
    ],
    commands: [
      "Compare [Outcome Variable] across groups of [Grouping Variable].",
      "Compar groups of [Grouping Variable] concerning [Variable 1], [Variable 2],...",
    ],
    example:
      "Compare age across groups of sex OR compare groups of sex concerning age, weight, height and ethnicity.",
  },
  {
    title: "Association Between Variables",
    triggers: ["association", "relationship", "related", "link", "effect", "impact", "influence"],
    commands: ["Assess the association between [Variable 1] and [Variable 2], [Variable 3]...."],
    example: "Assess the association between smoking and hypertension.",
  },
  {
    title: "Correlation Analysis",
    triggers: ["correlation", "correlate"],
    commands: ["Calculate the correlation between [Variable 1] and [Variable 2]."],
    example: "Calculate the correlation between age and BMI.",
  },
  {
    title: "Regression Analysis",
    triggers: [
      "regression",
      "model",
      "multivariable",
      "multivariate",
      "adjust",
      "adjusted",
      "control for",
      "confound",
      "predict",
      "odds ratio",
      "risk ratio",
      "estimate",
      "beta",
      "predictor",
      "dependent variable",
    ],
    commands: [
      "Build a regression model. Dependent variable : [Dependent Variable] , Predictors: [Predictor 1] , [Predictor 2] ...",
    ],
    example:
      "Build a regression model with preterm birth as the dependent variable and drug exposure as predictor, adjusting for age and parity.",
  },

  /* =========================
    MODEL-SPECIFIC REGRESSIONS
  ========================= */

  {
    title: "Logistic Regression",
    triggers: ["logistic", "logit"],
    commands: [
      "Run logistic regression. Dependent:[Dependent Variable], predictors: [Predictor 1], [Predictor 2], [Predictor 3]...",
    ],
    example:
      "Run logistic regression with preterm birth as the dependent variable and drug exposure as predictor.",
  },
  {
    title: "Linear Regression",
    triggers: ["linear regression", "ols"],
    commands: ["Run linear regression with [Outcome] as the dependent variable and [Predictors]."],
    example: "Run linear regression with BMI as the dependent variable and age and sex as predictors.",
  },
  {
    title: "Poisson Regression",
    triggers: ["poisson"],
    commands: ["Run Poisson regression with [Outcome] as the dependent variable and [Predictors]."],
    example:
      "Run Poisson regression with hospitalization count as the dependent variable and exposure as predictor.",
  },
  {
    title: "Negative Binomial Regression",
    triggers: ["negative binomial", "neg binom"],
    commands: ["Run negative binomial regression with [Outcome] as the dependent variable and [Predictors]."],
    example:
      "Run negative binomial regression with event count as the dependent variable and exposure as predictor.",
  },

  /* =========================
    EXACT STATISTICAL TESTS
  ========================= */

  {
    title: "Pearson Correlation",
    triggers: ["pearson", "pearson r"],
    commands: ["Perform Pearson correlation between [Variable 1] and [Variable 2]."],
    example: "Perform Pearson correlation between age and BMI.",
  },
  {
    title: "Spearman Correlation",
    triggers: ["spearman", "spearman rho"],
    commands: ["Perform Spearman correlation between [Variable 1] and [Variable 2]."],
    example: "Perform Spearman correlation between age and BMI.",
  },
  {
    title: "Chi-Square Test",
    triggers: ["chi square", "chi-square", "chisq"],
    commands: ["Perform a chi-square test between [Categorical Variable 1] and [Categorical Variable 2]."],
    example: "Perform a chi-square test between sex and smoking.",
  },
  {
    title: "Fisher Exact Test",
    triggers: ["fisher", "fisher exact"],
    commands: ["Perform Fisher's exact test between [Categorical Variable 1] and [Categorical Variable 2]."],
    example: "Perform Fisher's exact test between exposure and rare outcome.",
  },
  {
    title: "Independent t-test",
    triggers: ["t test", "t-test", "student t"],
    commands: [
      "Perform an independent t-test comparing [Outcome Variable] between groups of [Grouping Variable].",
    ],
    example: "Perform an independent t-test comparing age between sex groups.",
  },
  {
    title: "Mann–Whitney Test",
    triggers: ["mann whitney", "wilcoxon rank sum"],
    commands: [
      "Perform a Mann–Whitney test comparing [Outcome Variable] between groups of [Grouping Variable].",
    ],
    example: "Perform a Mann–Whitney test comparing BMI between exposure groups.",
  },
  {
    title: "ANOVA",
    triggers: ["anova"],
    commands: ["Perform ANOVA comparing [Outcome Variable] across groups of [Grouping Variable]."],
    example: "Perform ANOVA comparing BMI across ethnic groups.",
  },
  {
    title: "Kruskal–Wallis Test",
    triggers: ["kruskal", "kruskal wallis"],
    commands: [
      "Perform a Kruskal–Wallis test comparing [Outcome Variable] across groups of [Grouping Variable].",
    ],
    example: "Perform a Kruskal–Wallis test comparing BMI across ethnic groups.",
  },

  /* =========================
    WRITING ASSISTANCE
  ========================= */

  {
    title: "Generate Methods Section",
    triggers: ["methods", "methodology", "statistical methods"],
    commands: ["Generate a statistical methods section describing the analyses performed."],
    example: "Generate a statistical methods section describing the analyses performed.",
  },
  {
    title: "Generate Results Section",
    triggers: ["results section", "phrase results", "write results"],
    commands: ["Write a manuscript-ready results section based on this analysis."],
    example: "Write a manuscript-ready results section based on this analysis.",
  },
];

const MIN_TRIGGER_LENGTH = 2;

export const getMatchedSuggestions = (input) => {
  if (!input || input.trim().length < MIN_TRIGGER_LENGTH) return [];
  const lowerInput = input.toLowerCase().trim();
  return CHAT_SUGGESTIONS.filter(({ triggers }) =>
    triggers?.some((trigger) => trigger.startsWith(lowerInput) || lowerInput.includes(trigger))
  );
};

export const GOOGLE_FORM_REPORT_LINK =
  "https://docs.google.com/forms/d/e/1FAIpQLSeRkOG6BYGWm7GplaEb6KcBlbIDnO1FBbgheTIDS5CUDpKkbw/viewform";
